var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card action-card card-img-holder cursor-pointer text-white",
      class: [
        _vm.hovered || _vm.isSelected
          ? "bg-gradient-primary shadow-sm"
          : "bg-gradient-dark "
      ],
      on: {
        mouseenter: function($event) {
          return _vm.hover(true)
        },
        mouseleave: function($event) {
          return _vm.hover(false)
        },
        click: function($event) {
          return _vm.select()
        }
      }
    },
    [
      _c("div", { staticClass: "card-body p-3" }, [
        _c("img", {
          staticClass: "card-img-absolute",
          attrs: { src: "images/dashboard/circle.svg", alt: "circle-image" }
        }),
        _vm._v(" "),
        _c("h3", { staticClass: "mt-2" }, [
          _vm._v("\n            " + _vm._s(_vm.title) + "\n            "),
          _c("i", { staticClass: "mdi mdi-36px float-right", class: _vm.icon })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }